import { BadgeData } from './types';
import { StyledMiddleBadge } from './style';

function Badge(badgeData: BadgeData) {
    const emblemPic = badgeData.emblem?.imageUrl || badgeData.badge?.emblem?.imageUrl;
    const ribbonText = badgeData.ribbon?.text || badgeData.badge?.ribbon?.text;
    const background =
        emblemPic ?
            `url(${emblemPic})` :
            'url(https://media.appcharge.com/defaults/sale_ribbon_center.png)';

    return (
        <StyledMiddleBadge
            background={background}
            textColor={badgeData.ribbon?.textColor}
            position={badgeData.position || badgeData.badge?.position}
        >
            {ribbonText && (
                <p data-text={ribbonText}>{ribbonText}</p>
            )}
        </StyledMiddleBadge>
    );
}

export default Badge;
